const data = [
    {
        name: 'Location',
        data: '71-A Agno Ext. Brgy. Tatalon Quezon City',
        icon: 'bi bi-geo-fill'
    },
    {
        name: 'Email',
        data: 'sales2@alconph.com',
        icon: 'bi bi-envelope-at-fill',  
    },
    {
        name: 'Call',
        data: '0999-888-8336, 0999-888-8337',
        icon: 'bi bi-telephone-fill'
    }
]

export default data;